module.exports = __webpack_public_path__ + "static/hudson-zoom-17d783d1d5288fe9cec985edd859612d.jpg";